import ServiceBase from "@app/shared/serviceBase";
import { SpecialtyDefinition } from "@app/specialty-definitions/specialtyDefinitionModels";

export default class SpecialtyDefinitionService extends ServiceBase {
  public async getSpecialtyDefinitionById(specialtyDefinitionId: number): Promise<SpecialtyDefinition> {
    return await this.makeGet<SpecialtyDefinition>(`specialty-definitions/${specialtyDefinitionId}`);
  }
}
